import gql from 'graphql-tag';

export const approveFeedPostMutation = gql`
  mutation approveFeedPost($feedItemId: String!) {
    approveFeedPost(feedItemId: $feedItemId)
  }
`;
